import { render, staticRenderFns } from "./bo-cell-custom-toggle.vue?vue&type=template&id=2e6635d0"
import script from "./bo-cell-custom-toggle.vue?vue&type=script&lang=js"
export * from "./bo-cell-custom-toggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports